import styled from "styled-components";
import { hexToRGB } from "./util";

export const VerifierBody = styled.div`
	background-color: ${(props) => hexToRGB(props.theme.secondaryColor, props.theme.secondaryColorOpacity)};
	display: grid;
	grid-template-columns: 1rem 1fr 1rem;
	grid-template-rows: 4.4rem 1rem auto 1rem auto 1rem 20rem;
	@media (min-width: 992px) {
		// for larger screens
		min-height: 100vh;
		grid-template-columns: 2fr 9fr 1rem 9fr 2fr;
		grid-template-rows: 3.5rem 1rem 1fr 1rem 3.5rem;
	}
`;

export const SecondaryContent = styled.div`
	/* primary Card */
	grid-column-start: 2;
	grid-column-end: 3;
	grid-row-start: 5;
	grid-row-end: 6;
	display: flex;
	justify-content: center;
	padding: 1rem;
	min-height: 80vh;
	box-shadow: 0px 3px 10px rgba(163, 182, 204, 0.2);
	border-radius: 10px;
	background-color: white;

	@media (min-width: 992px) {
		// for larger screens
		grid-column-start: 4;
		grid-column-end: 5;
		grid-row-start: 3;
		grid-row-end: 4;
		padding: 1rem;
	}
`;

export const SpinnerBox = styled.div`
	grid-column-start: 2;
	grid-column-end: 3;
	grid-row-start: 3;
	grid-row-end: 4;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0.5rem;
	min-height: 80vh;
	box-shadow: ${({ isError }) => (isError ? "unset" : "0px 3px 10px rgba(163, 182, 204, 0.2)")};
	border-radius: 10px;
	background-color: ${({ isError }) => (isError ? "transparent" : "white")};
	@media (min-width: 992px) {
		// for larger screens
		grid-column-start: 2;
		grid-column-end: 5;

		grid-row-start: 3;
		grid-row-end: 4;
	}

	@media (max-width: 425px) {
		align-items: ${({ isError }) => (isError ? "start" : "center")};
	}
`;

export const PrimaryContent = styled.div`
	/* primary Card */
	grid-column-start: 2;
	grid-column-end: 3;
	grid-row-start: 3;
	grid-row-end: 4;
	display: flex;
	justify-content: center;
	padding: 1rem;
	min-height: 80vh;
	box-shadow: 0px 3px 10px rgba(163, 182, 204, 0.2);
	border-radius: 10px;
	background-color: white;

	@media (min-width: 992px) {
		// for larger screens
		grid-column-start: 2;
		grid-column-end: 3;
		grid-row-start: 3;
		grid-row-end: 4;
		padding: 1rem;
	}
`;

// Header section

export const Header = styled.div`
	grid-column-start: 1;
	grid-column-end: 4;
	grid-row-start: 1;
	grid-row-end: 2;
	background-color: white;
	display: flex;

	@media (min-width: 768px) {
		// for larger screens
		grid-column-end: 6;
		padding: 0.1rem 8vw;
	}
`;

export const HeaderContainer = styled.div`
	flex: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

export const HeaderSubContainer = styled.div`
	display: flex;
	align-items: center;
`;

export const HeaderLogo = styled.img`
	max-height: 3rem;
	height: auto;
	width: auto;
	@media (min-width: 768px) {
		// for larger screens
		max-height: ${({ whitelabeled }) => (whitelabeled ? "3.2rem" : "4rem")};
		height: auto;
		width: auto;
	}
`;

export const PrimaryAction = styled.div`
	display: flex;
	gap: 1rem;
	width: 100%;
`;

export const SubFooter1 = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	@media (min-width: 992px) {
		flex-direction: row;
	}
`;
export const SubFooter2 = styled.div`
	display: flex;
	flex-direction: column;
	@media (min-width: 992px) {
		flex-direction: row;
	}
`;
export const Footer = styled.div`
	display: flex;
	background-color: ${({ theme }) => theme?.footerBgColor || "black"};
	grid-column-start: 1;
	grid-column-end: 4;
	grid-row-start: 7;
	grid-row-end: 8;

	padding: 1.5rem;
	flex-direction: column;

	@media (min-width: 992px) {
		// for larger screens
		flex-direction: row;
		justify-content: ${({ justifyContent }) => justifyContent || "space-between"};
		padding: 0rem 8vw;
		align-items: center;
		grid-column-end: 6;
		grid-row-start: 5;
		grid-row-end: 6;
	}
`;

export const AdditionalContentResourcesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: auto;
	gap: 0.5rem;
	padding-bottom: 0.5rem;

	@media (max-width: 1024px) {
		// for smaller screens
		grid-template-columns: 1fr;
	}
`;

// Header
// Primary Content Secondary Content
// Footer
